import Icon from '@atoms/Icon/Icon';
import classNames from 'classnames';

interface IVideoButton {
  readonly videoSource?: string;
  readonly videoConfig?: string;
  readonly playButtonLabel: string;
  readonly darkFont: boolean;
  readonly onClick?: () => void;
}

export const VideoButton = ({
  videoSource,
  videoConfig,
  playButtonLabel,
  darkFont,
  onClick,
}: IVideoButton) => {
  let qbrickAttrs = {};

  if (videoSource && videoConfig) {
    qbrickAttrs = {
      'data-video': videoSource,
      'data-qbrick-config': videoConfig,
      'aria-controls': 'modal-video',
    };
  }
  return (
    <button
      {...qbrickAttrs}
      onClick={onClick}
      className="tw-mx-auto tw-flex tw-flex-col tw-items-center tw-rounded-full tw-shadow-black tw-transition-shadow hover:tw-shadow-xl"
    >
      <span className="sr-only">{playButtonLabel}</span>
      <div
        className={classNames(
          'tw-relative tw-h-16 tw-w-16 tw-rounded-full',
          darkFont ? 'tw-bg-grey-100' : 'tw-bg-white'
        )}
      >
        <Icon
          name="play"
          size={32}
          colorClassName={darkFont ? 'tw-text-white' : 'tw-text-grey-100'}
          className="tw-absolute tw-left-[30%] tw-top-1/2 -tw-translate-y-1/2"
        />
      </div>
    </button>
  );
};
